import { render, staticRenderFns } from "./MicrositesSidebar.vue?vue&type=template&id=2d2d4fc2&"
import script from "./MicrositesSidebar.vue?vue&type=script&lang=ts&"
export * from "./MicrositesSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MicrositesSidebar.vue?vue&type=style&index=0&id=2d2d4fc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports